<template>
	<div class="container-fluid no-gutter reseller">
		<Title />
		<MainForm/>
	</div>
</template>

<script>

	import Title from './Title.vue'
	import MainForm from './MainForm.vue'

	//import TitleH from './TitleH'
	export default {
		name: 'Reseller',
		props: {
			msg: String
		},
		components: {
			Title,
			MainForm
		},
	}
</script>

<style scoped>
	h1, h2, h3, p, button{
		color: #093547;
		font-family: 'Raleway', sans-serif;
		line-height: 25px;
	}
	/deep/.container-fluid{
		position: relative;
	}
</style>
